import { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link, useHistory } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from 'app/hooks'
import routes from 'app/routes'
import { H1 } from 'components/Typography'
import { WhiteBlock } from 'components/Layout'
import { CommonButton } from 'components/Button'
import { LoaderOverlay } from 'components/Loader'

import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import PaymentMethodsCardsList from './components/PaymentMethodsCardsList'
import { getPaymentMethodsListThunk } from './slice'
import {
  defaultPaymentMethodRequestSelectors,
  detachPaymentMethodSelectors,
  paymentMethodsListSelector,
} from './selectors'
import {
  AddPamentMethodButtonWrap,
  PaymentMethodsHeading,
  PaymentMethodsPageWrapper,
} from './styles'
import { paymentMethodsPageMessages } from './messages'

function PaymentMethodsPage() {
  const dispatch = useAppDispatch()
  const history = useHistory()

  const rootDomainId = useAppSelector(currentRootDomainIdSelector)
  const paymentMethods = useAppSelector(paymentMethodsListSelector.data)
  const isFetchingDetachPaymentMethod = useAppSelector(
    detachPaymentMethodSelectors.isFetching
  )
  const isFetchingPaymentMethodsList = useAppSelector(
    paymentMethodsListSelector.isFetching
  )
  const isFetchingDefaultPaymentMethod = useAppSelector(
    defaultPaymentMethodRequestSelectors.isFetching
  )

  const [loadedPaymentMethods, setLoadedPaymentMethods] = useState(false)

  const isLoading =
    isFetchingDetachPaymentMethod || isFetchingPaymentMethodsList

  useEffect(() => {
    const fetchPaymentMethods = async () => {
      if (rootDomainId) {
        await dispatch(getPaymentMethodsListThunk(rootDomainId))
        setLoadedPaymentMethods(true)
      }
    }
    fetchPaymentMethods()
  }, [dispatch, rootDomainId])

  useEffect(() => {
    if (loadedPaymentMethods && !paymentMethods?.length) {
      history.replace(routes.addPaymentMethod(rootDomainId))
    }
  }, [history, loadedPaymentMethods, paymentMethods?.length, rootDomainId])

  const addPaymentMethodPath = routes.addPaymentMethod(rootDomainId)

  if (isLoading || isFetchingDefaultPaymentMethod) {
    return <LoaderOverlay isFullScreen />
  }

  return (
    <PaymentMethodsPageWrapper>
      <PaymentMethodsHeading>
        <H1>
          <FormattedMessage {...paymentMethodsPageMessages.title} />
        </H1>
      </PaymentMethodsHeading>
      <WhiteBlock>
        <AddPamentMethodButtonWrap>
          <CommonButton
            variant="secondary"
            size="small"
            as={Link}
            to={addPaymentMethodPath}
          >
            <FormattedMessage {...paymentMethodsPageMessages.addMethod} />
          </CommonButton>
        </AddPamentMethodButtonWrap>
        <PaymentMethodsCardsList isFullPage />
      </WhiteBlock>
    </PaymentMethodsPageWrapper>
  )
}

export default PaymentMethodsPage
